import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { saveAs } from 'file-saver'
import moment from 'moment'

import { firebaseDb as db } from '../../firebase'
import { generateStatusTabs } from '../../helpers'

import { Button, Modal, Form, Radio, message, Checkbox } from 'antd'
const FormItem = Form.Item
const RadioGroup = Radio.Group

const notVisibleFields = ['id', 'lastCallAt', 'isInCall']

// generate a download
function s2ab (s) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff
  }
  return buf
}

class ExportData extends Component {
  state = {
    showModal: false,
    selectedFileType: 'csv'
  }

  handleModal = () => {
    this.setState(state => ({
      showModal: !state.showModal
    }))
  }

  exportContacts = async (fileType, includeLogs) => {
    const {
      match: { params },
      projects,
      contacts,
      t
    } = this.props

    const statusTabs = generateStatusTabs(projects[params.projectId].possibleCalls)

    import('xlsx')
      .then(XLSX => {
        const logsRef = db
          .collection('projects')
          .doc(params.projectId)
          .collection('logs')
        logsRef
          .get()
          .then(logsSnap => {
            const contactLogs = {}
            logsSnap.forEach(doc => {
              contactLogs[doc.data().contactId] = {
                ...contactLogs[doc.data().contactId],
                [doc.id]: doc.data()
              }
            })
            return contactLogs
          })
          .then(contactLogs => {
            // get current Project - for file name
            const currentProject = projects[params.projectId]

            let fileData = null

            switch (fileType) {
              case 'csv': {
                const contactsPreparedForExport = {}

                // create WorkBook
                const wb = XLSX.utils.book_new()

                // remove unwanted fields
                _.forEach(contacts, (contact, contactId) => {
                  contactsPreparedForExport[contactId] = _.omit(contact, [...notVisibleFields, 'logs'])
                })

                // create WorkSheet
                const ws = XLSX.utils.json_to_sheet(_.values(contactsPreparedForExport))
                XLSX.utils.book_append_sheet(wb, ws)

                fileData = XLSX.utils.sheet_to_csv(ws)

                break
              }

              case 'xlsx': {
                let tabContactsPreparedForExport = null

                // create a blank WorkBook
                const wb = { SheetNames: [], Sheets: {} }

                // create xlsx tabs, same as Tabs in Contacts list
                _.forEach(statusTabs, (tabTitle, statusId) => {
                  const tabContacts = _.filter(contacts, { status: parseInt(statusId, 10) })

                  tabContactsPreparedForExport = []

                  tabContacts.forEach(contact => {
                    let logsCellData = ''

                    if (includeLogs) {
                      // assign the ContactLogs to current Contact, use data in a single cell

                      if (contactLogs[contact.id]) {
                        const contactLogsOrdered = _.orderBy(contactLogs[contact.id], 'createdAt', 'asc')

                        // render selected fields for each of the logs
                        _.forEach(contactLogsOrdered, log => {
                          // log datetime
                          logsCellData += moment(log.createdAt).format('MM.DD.YYYY, HH:mm')

                          // status name
                          logsCellData += ' (' + t(`contact.status.${statusTabs[log.status]}`) + ') \n'

                          if (log.data && log.data.comment) {
                            logsCellData += 'COMMENT: ' + log.data.comment + '\n'
                          }

                          // if contact was reached (status 11-15), render questions and answers
                          if ([11, 12, 13, 14, 15].includes(log.status) && _.size(log.data.questions)) {
                            const currentProject = projects[params.projectId]
                            const projectQuestions = currentProject.questions

                            logsCellData += 'QUESTIONS: \n'

                            _.forEach(log.data.questions, (answer, questionId) => {
                              if (projectQuestions[questionId]) {
                                // use question text
                                logsCellData += '•' + projectQuestions[questionId].text + '\n'
                              } else {
                                // or 'questionId' if question doesn't exist anymore
                                logsCellData += '•' + questionId + '\n'
                              }

                              logsCellData += '-' + answer + '\n'
                            })
                          }

                          logsCellData += '\n'
                        })
                      }
                    } // END: if (includeLogs) {}

                    // remove unwanted fields
                    tabContactsPreparedForExport.push(
                      _.omit(
                        {
                          ...contact,
                          logs: includeLogs ? logsCellData : undefined
                        },
                        notVisibleFields
                      )
                    )
                  })

                  const ws = XLSX.utils.json_to_sheet(tabContactsPreparedForExport)
                  const tabTitleTranslation = t(`contact.status.${tabTitle}`)

                  wb.SheetNames.push(tabTitleTranslation)
                  wb.Sheets[tabTitleTranslation] = ws
                }) // END: _.forEach(statusTabs, (tabTitle, statusId) => {})

                fileData = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

                break
              }

              default:
                break
            }

            saveAs(
              new Blob([s2ab(fileData)], { type: 'application/octet-stream' }),
              `${currentProject.name}.${fileType}`
            )

            this.handleModal()
          })
          .catch(error => {
            console.log('Firebase error: ', error)
          })
      })
      .catch(err => {
        message.error('Problem with network, try again later')
        console.log('XLSX library not loaded' + err)
      })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        this.exportContacts(values.fileType, values.includeLogs)
      }
    })
  }

  handleFileTypeChange = e => {
    const selectedFileType = e.target.value

    this.setState({ selectedFileType })
  }

  render () {
    const {
      form: { getFieldDecorator }
    } = this.props

    return (
      <span>
        <Button icon='download' onClick={() => this.handleModal()}>
          Export Contacts
        </Button>

        <Modal visible={this.state.showModal} onCancel={this.handleModal} footer={null}>
          <Form onSubmit={this.handleSubmit}>
            <FormItem label='Export as'>
              {getFieldDecorator('fileType', {
                initialValue: 'csv'
              })(
                <RadioGroup onChange={this.handleFileTypeChange}>
                  <Radio value='csv'>CSV</Radio>
                  <Radio value='xlsx'>XLSX</Radio>
                </RadioGroup>
              )}
            </FormItem>

            {this.state.selectedFileType === 'xlsx' && (
              <FormItem>
                {getFieldDecorator('includeLogs', {
                  initialValue: true,
                  valuePropName: 'checked'
                })(<Checkbox>Include Contact logs</Checkbox>)}
              </FormItem>
            )}

            <Button icon='download' type='primary' htmlType='submit'>
              Export
            </Button>
          </Form>
        </Modal>
      </span>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  contacts: state.contacts,
  companies: state.companies
})

export default connect(mapStateToProps)(Form.create()(withRouter(translate('translations')(ExportData))))



// WEBPACK FOOTER //
// ./src/components/Contacts/ExportContacts.js